<template>
  <section class="hero-banner">
    <img class="banner-bg" src="@/static/image/bg_img/index-banner.png" alt="index-banner" />
    <div class="hero-mask"></div>

    <div class="hero-content section">
      <div class="swip-desc">
        <div class="h1">{{ $t('heroBanner.title') }}</div>
        <div class="line"></div>
        <div class="tag">{{ $t('heroBanner.slogan') }}</div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'HeroBanner'
}
</script>

<style scoped lang="scss">
.hero-banner {
  position: relative;
  width: 100%;
  height: 780px;
  overflow: hidden;
}

.banner-bg {
  width: 100%;
  height: 100%;
  display: block;
  object-fit: cover;
}

.hero-mask {
  position: absolute;
  inset: 0;
  background: linear-gradient(90deg, rgba(28, 81, 163, 0.88) 0%, rgba(28, 81, 163, 0.68) 22%, rgba(28, 81, 163, 0.18) 52%, rgba(28, 81, 163, 0) 70%);
}

.section {
  width: 1200px;
  margin: 0 auto;
}

.hero-content {
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  height: 100%;
  display: flex;
  align-items: center;
}

.swip-desc {
  color: #fff;
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.h1 {
  font-size: 86px;
  line-height: 1;
  font-weight: 700;
  letter-spacing: 2px;
  margin: 0;
}

.line {
  width: 360px;
  height: 6px;
  background: #ffffff;
  margin-top: 26px;
}

.tag {
  margin-top: 32px;
  font-size: 42px;
  line-height: 1.3;
  font-weight: 400;
  text-align: left;
}

@media (max-width: 1400px) {
  .hero-banner {
    height: 680px;
  }

  .section {
    width: 90%;
    min-width: 1200px;
  }

  .h1 {
    font-size: 76px;
  }

  .tag {
    font-size: 34px;
  }
}
</style>
